import Swal from "sweetalert2";

const sweetConfirmationDeleteAccount = () => {
  return Swal.fire({
    title: "Delete Account",
    text: "Are you sure you want to Delete Account?",
    icon: "question",
    showCancelButton: true,
    confirmButtonColor: "#dc3545",
    cancelButtonColor: "#6c757d",
    confirmButtonText: "Yes, Delete",
    cancelButtonText: "Cancel",
    reverseButtons: true, // Makes Cancel appear on the left
  }).then((result) => {
    return {
      dismiss: result.dismiss,
      isConfirmed: result.isConfirmed,
      isDenied: result.isDenied,
      isDismissed: result.isDismissed,
    };
  });
};

export default sweetConfirmationDeleteAccount;
